import React from 'react';
import { faUniversalAccess } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Header = () => {
    return (
        <header>
            <p className="bannerTitle">
                <a href="https://github.com/techyscouts/a11y-audit">
                    .//a11y
                </a>&nbsp;
                <FontAwesomeIcon icon={faUniversalAccess} color="#3e50b4" size="lg" />
            </p>
        </header>
    );
};

export default Header;
